import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * PenSparkle icon
 *
 * @category Files/Forms/Editing
 */
const PenSparkle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M7.799 10.512a1 1 0 0 0 1 1h2.193a.3.3 0 0 1 .3.3v.4a.3.3 0 0 1-.3.3H8.799a1 1 0 0 0-1 1v2.168a.3.3 0 0 1-.3.3h-.4a.3.3 0 0 1-.3-.3v-2.168a1 1 0 0 0-1-1H3.605a.3.3 0 0 1-.3-.3v-.4a.3.3 0 0 1 .3-.3h2.194a1 1 0 0 0 1-1v-2.17a.3.3 0 0 1 .3-.3h.4a.3.3 0 0 1 .3.3zm6.233-4.272a.5.5 0 0 0 .5.5h.941a.3.3 0 0 1 .3.3v.4a.3.3 0 0 1-.3.3h-.94a.5.5 0 0 0-.5.5v.927a.3.3 0 0 1-.3.3h-.4a.3.3 0 0 1-.3-.3V8.24a.5.5 0 0 0-.5-.5h-.941a.3.3 0 0 1-.3-.3v-.4a.3.3 0 0 1 .3-.3h.94a.5.5 0 0 0 .5-.5v-.926a.3.3 0 0 1 .3-.3h.4a.3.3 0 0 1 .3.3zm15.153 2.824c-.636-1.039-2.535-2.636-3.395-3.563-.525-.447-1.162-.77-1.597-.268-1.81 1.82-15.078 15.078-16.407 16.418-.347.391-.313.48-.592 1.184-.402 1.117-1.34 3.641-1.754 4.77-.324.77-.1 1.608.905 1.317 1.519-.58 4.847-1.62 6.199-2.423.659-.648 8.455-8.455 13.168-13.168l2.893-2.893c.49-.48.781-.704.614-1.273l-.045-.1zM6.702 27.392c0-.58.648-1.887.883-2.602.245-.547.368-1.251.76-1.553.714-.1 1.295.939 2.065 1.553 1.52 1.34-.368 1.653-1.362 2.033-.615.156-1.91.86-2.312.648zm5.093-2.1c-.547-.39-1.965-1.865-2.502-2.423-.234-.257-.457-.603-.279-.883 1.787-1.82 11.158-11.157 14.81-14.81.402-.39 1.028-1.217 1.675-.49.648.692 2.067 1.797 2.39 2.613-.77 1.485-3.45 3.518-6.187 6.5-2.982 2.837-7.07 7.438-9.829 9.516l-.089-.023z"
        />
      </svg>
    );
  }
);

PenSparkle.displayName = 'PenSparkle';

export { PenSparkle };
